import { motion } from 'framer-motion';

export const EASE = [0.16, 1, 0.3, 1];

const LINE = { hidden: { y: '112%' }, show: { y: '0%' } };

// L'ingresso nello schermo si osserva sul contenitore (sempre visibile):
// le righe partono nascoste dentro la maschera e non verrebbero mai "viste" dal browser.
export default function MaskLines({ lines, className = '', lineClassName = '', delay = 0, load = false }) {
  const trigger = load
    ? { initial: 'hidden', animate: 'show' }
    : { initial: 'hidden', whileInView: 'show', viewport: { once: true, amount: 0.35 } };
  return (
    <motion.span className={'block ' + className} {...trigger}>
      {lines.map((line, i) => (
        <span className="mask-line" key={i}>
          <motion.span
            variants={LINE}
            transition={{ duration: 0.95, ease: EASE, delay: delay + i * 0.1 }}
            className={lineClassName}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}
